<template>
  <table :class="['product-rows', { 'product-rows--use-multiselect': mq('to-medium') && (rows !== undefined && rows.length > 0 )}]">
    <thead>
      <tr>
        <th class="product-row__head-remove">
          <div class="product-row__head-inset">
            <oie-base-checkbox v-model="selectAll" is-for="order-history-select-all" :text="mq('to-medium') ? tStatic('cartProductHeaderSelectAllLabel') : null"></oie-base-checkbox>
          </div>
        </th>

        <th class="product-row__head-image"></th>

        <th class="product-row__head-article-name">
          <div v-epi-edit="'articleNameHeader'" class="product-row__head-inset">
            <span>
              {{ t('articleNameHeader') }}
              <!-- Artikelnamn -->
            </span>
          </div>
        </th>

        <th class="product-row__head-stock-status">
          <div v-epi-edit="'articleCountHeader'" class="product-row__head-inset">
            {{ t('articleCountHeader') }}
            <!-- Antal artiklar -->
          </div>
        </th>

        <th class="product-row__head-quantity">
          <div v-epi-edit="'articleDeliveredCountHeader'" class="product-row__head-inset">
            {{ t('articleDeliveredCountHeader') }}
          </div>
        </th>

        <th class="product-row__head-quantity">
          <div v-epi-edit="'articleDeliveredCountHeader'" class="product-row__head-inset">
            {{ t('articleNotSentCountHeader') }}
          </div>
        </th>

        <th class="product-row__head-comment">
          <div v-epi-edit="'rowCommentHeader'" class="product-row__head-inset">
            {{ t('rowCommentHeader') }}
            <!-- Kommentar -->
          </div>
        </th>

        <th class="product-row__head-item-price">
          <div v-epi-edit="'rowSumExcludedVatHeader'" class="product-row__head-inset product-row__head-inset--align-right">
            <span>{{ t('rowSumExcludedVatHeader') }}<!--Summa (exkl. moms)--></span>
          </div>
        </th>

        <!-- <th class="product-row__head-total-price">
          <div v-epi-edit="'rowSumHeader'" class="product-row__head-inset product-row__head-inset--align-right">
            <span>{{ t('rowSumHeader') }}</span>
          </div>
        </th> -->
      </tr>
    </thead>

    <tbody>
      <tr v-for="(row, key) in rows" :key="`table-row-${key}`">
        <td class="product-row__body-td--checkbox">
          <div class="product-row__body-inset product-row__body-inset--select">
            <oie-base-checkbox
              v-if="isRowSelectable(row)"
              v-model="selectedRows"
              :val="row"
              size="medium"
              :is-for="`history-details-product-${key}`"></oie-base-checkbox>
          </div>
        </td>

        <td class="product-row__body-td--image">
          <div class="product-row__body-inset">
            <oie-base-image
              :images="row.imageUrl ? getAssetPath(`${row.imageUrl}?preset=ProductSmall&watermark=OIEWatermarkSmall`) : getAssetPath('/globalassets/missing404/404.png?preset=ProductSmall')"
              :alt-text="row.artName"
              image-width="3.75rem"
              image-height="3.75rem"
              class="product-row__image"></oie-base-image>
          </div>
        </td>

        <td class="product-row__body-td--article">
          <div v-if="row.url" class="product-row__body-inset product-row__body-inset--article">
            <a :href="row.url" class="product-row__name">
              {{ row.artName }}

              <div class="product-row__article-number">
                {{ t('articleNumberLabel') }} {{ row.artNr }}
              </div>
            </a>
          </div>
          <div v-else-if="!row.url" class="product-row__body-inset product-row__body-inset--article">
            <div class="product-row__article-number">
              {{ t('articleNumberLabel') }} {{ row.artNr }}
            </div>
          </div>
        </td>

        <td>
          <div v-if="mq('to-medium')" class="product-row__body-header">
            {{ t('articleCountHeader') }}
          </div>

          <div class="product-row__body-inset">
            {{ row.quantity }}
          </div>
        </td>

        <td>
          <div v-if="mq('to-medium')" class="product-row__body-header">
            {{ t('articleDeliveredCountHeader') }}
          </div>

          <div class="product-row__body-inset">
            {{ row.deliveredQuantity }}
          </div>
        </td>

        <td>
          <div v-if="mq('to-medium')" class="product-row__body-header">
            {{ t('articleNotSentCountHeader') }}
          </div>

          <div class="product-row__body-inset">
            <div v-if="row.remainingQuantity > 0" v-tooltip.top="row.estimatedDeliveryDescription">
              {{ row.remainingQuantity }}
            </div>
          </div>
        </td>

        <td class="product-row__td--comment">
          <div v-if="mq('to-medium')" class="product-row__body-header">
            {{ t('rowCommentHeader') }}
          </div>

          <div class="product-row__body-inset">
            {{ row.comment }}
          </div>
        </td>

        <td>
          <div v-if="mq('to-medium')" class="product-row__body-header">
            {{ t('rowSumExcludedVatHeader') }}
          </div>

          <div class="product-row__body-inset product-row__body-inset--align-right product-row__body-inset--price">
            {{ formatPrice(row.priceExcludedVat) }}
          </div>
        </td>
      </tr>
    </tbody>
  </table>
</template>

<script>
import _ from 'lodash'

export default {
  props: {
    rows: {
      type: Array,
      default: () => []
    }
  },
  data: () => ({
    selectedRows: [],
    unselectedRows: []
  }),
  computed: {
    selectableRows() {
      // Filter out rows that cannot be added to cart:
      // 1. Shipping rows (no URL)
      // 2. Articles with 0 price or no price (status 4)
      // 3. Articles with status "Publiceras utgått" (6)
      // 4. Articles with status "Publiceras ej" (2)
      return _.filter(this.rows, (row) => {
        // Must have a URL (not a shipping row)
        if (!row.url) {
          return false
        }

        // Check for problematic publication statuses
        if (row.publicationStatusCode === 2 || row.publicationStatusCode === 4 || row.publicationStatusCode === 6) {
          return false
        }

        // Check for zero price
        if (row.priceExcludedVat === 0 || row.priceExcludedVat == null) {
          return false
        }

        return true
      })
    },
    selectAll: {
      get() {
        const unselectedSelectableRows = _.filter(this.selectableRows, (row) => !_.includes(this.selectedRows, row))

        return this.selectedRows.length > 0 && unselectedSelectableRows.length === 0 && this.selectableRows.length > 0
      },
      set(value) {
        if (!value) {
          this.selectedRows = []
        } else {
          this.selectedRows = [...this.selectableRows]
        }
      }
    }
  },
  watch: {
    selectedRows(rows) {
      this.publish('order-history-rows-selection-updated', rows)
    }
  },
  methods: {
    isRowSelectable(row) {
      // Same logic as in selectableRows computed property
      // Must have a URL (not a shipping row)
      if (!row.url) {
        return false
      }

      // Check for problematic publication statuses
      if (row.publicationStatusCode === 2 || row.publicationStatusCode === 4 || row.publicationStatusCode === 6) {
        return false
      }

      // Check for zero price
      if (row.priceExcludedVat === 0 || row.priceExcludedVat == null) {
        return false
      }

      return true
    },
    formatDate(dateStr) {
      if (!dateStr) {
        return null
      }

      try {
        const date = new Date(dateStr)

        if (isNaN(date.getTime())) {
          return null
        }

        return date.toISOString().split('T')[0]
      } catch (error) {
        return ''
      }
    }
  }
}
</script>
